import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {WalletDetail} from "./wallet-detail";

const WalletDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/wallets');
    }

    return (
        <WalletDetail id={id ? parseInt(id) : null} onClose={onClose}/>
    )

});

export default WalletDetailPage;